<template>
  <div class="card-article-swatch card-swatch col-sm-4 col-md-3" :data-id="id" v-if="data">
    <div class="card-thumbnail">
      <div
        class="image"
        :style="{ backgroundImage: 'url(' + data.thumbnail + ')' }"
        @click.prevent="showSwatchDetail"
        ></div>
      <a
        v-if="onInspirationBoard"
        href="#remove-from-board"
        @click.prevent="removeSwatchFromInspirationBoard"
        ></a>
    </div>
    <div class="card-article-name-line">
      {{ articles[`id${data.article}`].name }} <a class="info" @click="setSlideoutArticle()"></a>
    </div>
    <div class="card-swatch-name-line">{{ data.name }}</div>
  </div>
</template>

<script>
export default {
  name: 'SwatchCard',
  props: {
    id: Number,
    articles: Object,
    swatches: Object,
    inspirationBoard: Array,
  },
  computed: {
    data() {
      return this.swatches[`id${this.id}`]
    },
    onInspirationBoard() {
      return this.inspirationBoard.indexOf(this.id) >= 0
    },
  },
  methods: {
    showSwatchDetail() {
      this.$emit('show-swatch-detail', this.id)
    },
    removeSwatchFromInspirationBoard() {
      this.$emit('remove-swatch-from-inspiration-board', this.id)
    },
    setSlideoutArticle() {
      this.$emit('set-slideout-article', this.data.article)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/SwatchCard.vue